import type { InjectionKey } from '@vue/composition-api'

export type AnchorScrollInject = {
  registerAnchor: (options: { el: HTMLElement; id: string }) => void
  unregisterAnchor: (id: string) => void
  onLinkWrapperSizeChange: () => void
}

export const anchorScrollNextInjectKey = Symbol('GAnchorScrollNextNameSpace') as InjectionKey<AnchorScrollInject>
